import { gtmPush } from "../helpers/gtm";

const ANALYTICS_VERSION = "1.0.0";

const buildEvent = (event, email) => ({
  event,
  user: {
    email,
  },
  meta: {
    timestamp: new Date().toISOString(),
    version: ANALYTICS_VERSION,
  },
});

export const analyticsService = {
  login(email) {
    gtmPush(buildEvent("user_logged_in", email));
  },
  logout(email) {
    gtmPush(buildEvent("user_logged_out", email));
  },
};